import calls from '@/backend/api-calls'

const state = () => ({
  orders: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    project_id: null
  },
  currencyOptions: ['USD', 'CAD', 'EUR', 'GBP']
})

// getters
const getters = {
  orderIds: state => {
    return state.orders.map(d => d.id);
  }
}

// actions
const actions = {
  getOrders: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.orders.get(parameters)
        .then(resp => {
          commit("setOrders", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addOrder({commit}, { data, parameters }) {
    return new Promise((resolve, reject) => {
      calls.orders.post(data, parameters)
        .then(resp => {
          commit("insertOrder", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateOrder: ({commit}, { orderId, data }) => {
    return new Promise((resolve, reject) => {
      calls.order.put(orderId, data).then(
        resp => {
          commit("insertUpdatedOrder", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Order successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteOrder: ({commit}, orderId) => {
    return new Promise((resolve, reject) => {
      calls.order.delete(orderId).then(
        resp => {
          commit("removeOrder", orderId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Order successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addDetail: ({commit}, detail) => {
    return new Promise((resolve, reject) => {
      calls.orderDetails.post(detail).then(
        resp => {
          commit("insertOrderDetail", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addBomDetail: ({commit}, detail) => {
    return new Promise((resolve, reject) => {
      calls.orderDetailsBoms.post(detail).then(
        resp => {
          commit("insertOrderDetail", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.orderIds);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setOrders(state, data) {
    state.pagination = data.pagination;
    state.orders = data.results;
  },
  insertOrder(state, data) {
    state.orders.push(data);
  },
  insertUpdatedOrder(state, data) {
    state.orders.forEach((order, i) => {
      if (order.id == data.id) {
        state.orders.splice(i, 1, data);
      }
    })
  },
  removeOrder(state, orderId) {
    state.orders.forEach((order, i) => {
      if (order.id == orderId) {
        state.orders.splice(i, 1);
      }
      const index = state.selected.indexOf(orderId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  insertOrderDetail(state, orderDetail) {
    state.orders.forEach(order => {
      if (order.id == orderDetail.order_id) {
        order.details.push(orderDetail);
      }
    })
  },
  selectAll(state, orderIds) {
    state.allSelected = true;
    orderIds.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}